import { connect } from "react-redux";
import {
  Grid,
  useTheme,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';

const AuthenticationLoadingBemyself = (props) => {
    const theme = useTheme();
    const classes = useStyles();
    return (
        <Grid container style={{ minHeight: 'calc(100vh - 0px)' }}>
            <Grid item md={12} xs={12} className={classes.gridOrderData} style={{ background: theme.palette.secondary.light, display:"flex", justifyContent:"center" }}>
                <Box style={{ display: "flex", alignItems:"center", justifyContent:"center", height:"98%" }} >
                    <Box style={{ textAlign:"center", maxWidth:"550px", width:"100%", padding:"32px" }}>                        
                        <CircularProgress color="secondary" size={50} />
                        {/* <Typography style={{ color: '#ccc', paddingTop: 20 }} variant="h1" component="h4">
                          Redireccionando...
                        </Typography> */}
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

AuthenticationLoadingBemyself.propTypes = {
};
const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, {
})(AuthenticationLoadingBemyself);

const useStyles = makeStyles((theme) => ({
    gridOrderFirst: {
        [theme.breakpoints.up('md')]: {
            order: 1,
        },
        [theme.breakpoints.down('md')]: {
            order: 2,
        },
    },
    gridOrderData: {
        [theme.breakpoints.down('md')]: {
            order: 1,
        },
        [theme.breakpoints.up('md')]: {
            order: 2,
        },
    },
}));